var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IoBackspace } from 'react-icons/io5';
import KeypadButton from './KeypadButton';
export var createKeypadButton = function (key, index, theme, ownerProps) {
    var buttonSize = ownerProps.buttonSize, value = ownerProps.value, onChange = ownerProps.onChange, onBackspace = ownerProps.onBackspace, onSubmit = ownerProps.onSubmit;
    var numberKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    var isActive = function (key) { return ((value === null || value === void 0 ? void 0 : value.includes(key)) ? 'active' : ''); };
    var Element = ownerProps.KeypadButton || KeypadButton;
    if (key === null)
        return _jsx("span", {}, "hidden-key-".concat(index));
    if (numberKeys.includes(key))
        return (_jsx(Element, __assign({ className: isActive(key), onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(key); }, size: buttonSize, shortcut: key, disabled: value && value.length >= 3, previewMode: ownerProps.previewMode }, { children: key }), "keypad-".concat(key)));
    if (key === 'Backspace')
        return (_jsx(Element, __assign({ shortcut: key, className: "HxKeypad-backspace", onClick: function () { return onBackspace === null || onBackspace === void 0 ? void 0 : onBackspace(); }, size: buttonSize, previewMode: ownerProps.previewMode }, { children: _jsx(IoBackspace, {}) }), "keypad-Backspace"));
    if (key === 'Enter')
        return (_jsx(Element, __assign({ shortcut: key, className: "HxKeypad-submit", onClick: function () { return onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(); }, disabled: value && value.length < 3, size: buttonSize, previewMode: ownerProps.previewMode }, { children: "OK" }), "keypad-Enter"));
};
